/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { getOriginalPicture } from '@braindate/util/lib/image';

import BraindateBrandedLogoIcon from 'src/shared/ui/component/icon/BraindateBrandedLogoIcon';
import messages from 'src/shared/app/nav/l10n/navigationL10n';

import styles from './EventBranding.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import ResponsivePicture from '@braindate/ui/lib/component/ResponsivePicture';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { homeRoute } from 'src/shared/app/base/route/setting/routeSettings';

import type { Picture } from '@braindate/domain/lib/base/type';

type Props = {
  variant: typeof large | typeof xlarge,
  logo: Picture | null,
  logoAltText: string,
  hasCustomBraindateName: boolean,
  hasSponsors: boolean,
};

const useStyles = createUseThemeStyles(styles);

const EventBrandingDumb = ({
  variant,
  logo,
  logoAltText,
}: Props): React.Node => {
  const intl = useIntl();
  let imgWidth = 80;

  if (variant === large) {
    imgWidth = 140;
  } else if (variant === xlarge) {
    imgWidth = 313;
  }

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [homePath] = useRoutes(homeRoute);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({ imgWidth });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const hasLogo = !!logo && !!getOriginalPicture(logo);

  return (
    <Link
      className={classes.root}
      to={homePath}
      aria-label={intl.formatMessage(messages.homePage)}
    >
      {hasLogo ? (
        <>
          <ResponsivePicture
            layoutClass={classes.logo}
            picture={logo}
            alt={logoAltText}
            displayWidth={imgWidth}
          ></ResponsivePicture>
        </>
      ) : (
        <>
          <BraindateBrandedLogoIcon />
        </>
      )}
    </Link>
  );
};

export const large = Symbol();
export const xlarge = Symbol();

export default React.memo<Props>(EventBrandingDumb);
